import React from "react";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { SkeletonAssinaturaContainer } from "./styles";

const SkeletonAssinatura: React.FC = () => {
  const { theme } = useTheme();

  return (
    <SkeletonAssinaturaContainer theme={theme}>
      <div className="col-esquerda">
        <div className="bloco-titulo" />
        <div className="bloco-alto" />
        <div className="bloco" style={{ "--i": 1 } as React.CSSProperties} />
        <div className="bloco" style={{ "--i": 2 } as React.CSSProperties} />
        <div className="bloco" style={{ "--i": 3 } as React.CSSProperties} />
      </div>
      <div className="col-divisor" />
      <div className="col-direita">
        <div className="bloco-titulo" />
        <div className="bloco" style={{ "--i": 4 } as React.CSSProperties} />
        <div className="bloco" style={{ "--i": 5 } as React.CSSProperties} />
        <div className="bloco" style={{ "--i": 6 } as React.CSSProperties} />
      </div>
    </SkeletonAssinaturaContainer>
  );
};

export default SkeletonAssinatura;
